import qs from "query-string";
var GOOGLE_MAPS_BASE_URL = "https://maps.google.com";
export var buildGoogleMapsLinkUrl = function buildGoogleMapsLinkUrl(_ref) {
  var latitude = _ref.latitude,
    longitude = _ref.longitude;
  var queryString = qs.stringify({
    q: "".concat(latitude, ",").concat(longitude)
  });
  return "".concat(GOOGLE_MAPS_BASE_URL, "/?").concat(queryString);
};